function CHUKHomeBody() {
  return (
    <>
      <div className="container-fluid p-4 body-font">
        <div className="row">
          <div className="col-xs-12 col-md-6 py-md-5">
            <p className="h6">
              <b>Car sharing made easy</b>
            </p>
            <p className="h1">
              <b>Book. Get in.</b>
              <font className="text-warning">
                <b> Drive!</b>
              </font>
            </p>
            <p className="h6">
              We’ve made renting with Hertz 24/7® so easy and quick that you can
              be in your vehicle within 15 minutes.
            </p>
            <div className="row">
              <div className="col-xs-12 col-md-6" style={{ textAlign: "left" }}>
                <div className="row">
                  <div
                    className="col-xs-12 col-md-5"
                    style={{ textAlign: "left" }}
                  >
                    <a href="https://apps.apple.com/de/app/hertz-24-7-mobility/id6453605078">
                      <img
                        className="img-fluid"
                        src="https://images.hertz.com/content/dam/hod/images/en-gb/static/AppleAppStore.png"
                        alt=""
                        width={250}
                        style={{
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                          backgroundRepeat: "no-repeat",
                        }}
                      />
                    </a>
                  </div>
                  <div
                    className="col-xs-12 col-md-1"
                    style={{ textAlign: "center" }}
                  >
                    &nbsp;
                  </div>
                  <div
                    className="col-xs-12 col-md-5"
                    style={{ textAlign: "left" }}
                  >
                    <a href="https://play.google.com/store/apps/details?id=com.hertz247.driverApp&hl=de_de&gl=de">
                      <img
                        className="img-fluid"
                        src="https://images.hertz.com/content/dam/hod/images/en-gb/static/GooglePlayStore.png"
                        alt=""
                        width={250}
                        style={{
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                          backgroundRepeat: "no-repeat",
                        }}
                      />
                    </a>
                  </div>
                  <div
                    className="col-xs-12 col-md-1"
                    style={{ textAlign: "center" }}
                  >
                    &nbsp;
                  </div>
                </div>
              </div>
              <div className="col-xs-12 col-md-6"></div>
            </div>
          </div>
          <div className="col-xs-12 col-md-6" style={{ textAlign: "right" }}>
            <img
              className="img-fluid"
              src="https://images.hertz.com/content/dam/hod/images/en-gb/static/Mercedes_24sprinter_top.png"
              alt=""
            />
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12" style={{ textAlign: "center" }}>
            <h1 className="display-5">
              <b>How it works</b>
            </h1>
            <br />
            <p className="h6">
              We’ve made renting with Hertz 24/7® so easy and quick that you can
              be in your vehicle within 15 minutes. And here’s how it works.
            </p>
            <br />
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12 col-md-3" style={{ textAlign: "center" }}>
            <img
              className="img-fluid"
              src="https://images.hertz.com/content/dam/hod/images/en-gb/static/QR_large.png"
              alt=""
            />
            <br />
            <br />
            <p className="h2">
              <b>01</b>
            </p>
            <br />
            <p className="h2">Download the app</p>
            <p>
              You can quickly and easily download the Hertz 24/7 app from your
              app store by scanning the QR code.
            </p>
          </div>
          <div className="col-xs-12 col-md-3" style={{ textAlign: "center" }}>
            <img
              style={{ width: "240px", borderRadius: "15px" }}
              className="img-fluid"
              src="https://images.hertz.com/content/dam/hod/images/de-de/static/247_DL_CH.png"
              alt=""
            />
            <br />
            <br />
            <p className="h2">
              <b>02</b>
            </p>
            <br />
            <p className="h2">Registration</p>
            <p>
              Simply create your membership profile and submit your documents
              for verification using the in-app photo feature.
            </p>
          </div>
          <div className="col-xs-12 col-md-3" style={{ textAlign: "center" }}>
            <img
              style={{
                width: "260px",
                borderRadius: "15px",
                border: "1px solid #ccc",
              }}
              className="img-fluid"
              src="https://images.hertz.com/content/dam/hod/images/en-gb/static/Select_Location_CH.png"
              alt=""
            />
            <br />
            <br />
            <p className="h2">
              <b>03</b>
            </p>
            <br />
            <p className="h2">Book your vehicle</p>
            <p>
              Log in to the app and book your vehicle by selecting your
              preferred location and pick-up time. You will need a credit/debit
              card.
            </p>
          </div>
          <div className="col-xs-12 col-md-3" style={{ textAlign: "center" }}>
            <img
              className="img-fluid"
              src="https://images.hertz.com/content/dam/hod/images/en-gb/static/Unlock.png"
              alt=""
            />
            <br />
            <br />
            <p className="h2">
              <b>04</b>
            </p>
            <br />
            <p className="h2">Start rental</p>
            <p>
              Shortly before your rental begins, the vehicle will be assigned to
              you. At pick-up, you will receive the digital key in the app to
              unlock the vehicle.
            </p>
          </div>
        </div>

        <div className="row" style={{ backgroundColor: "#F3F3F3" }}>
          <div className="col-xs-12" style={{ textAlign: "center" }}>
            <br />
            <h1 className="display-5">
              <b>Our fleet</b>
            </h1>
            <br />
            <p className="h6">
              Hertz 24/7® has the right vehicle for every occasion. Simply
              choose the vehicle that suits you and you’re ready to hit the
              road.
            </p>
            <br />
            <div className="row">
              <div
                className="col-xs-12 col-md-6"
                style={{ textAlign: "center" }}
              >
                <img
                  className="img-fluid"
                  src="https://images.hertz.com/content/dam/hod/images/en-gb/static/FordTransitLWB%20.png"
                  alt=""
                />
                <br /> <br />
                <div className="row">
                  <div
                    className="col-xs-12 col-md-4"
                    style={{ textAlign: "center" }}
                  ></div>
                  <div
                    className="col-xs-12 col-md-5"
                    style={{ textAlign: "center" }}
                  >
                    <div style={{ textAlign: "left" }}>
                      <p className="h2">Opel Movano</p>
                      <p className="h6">or similar</p>
                      <span>
                        <ul>
                          <li>Doors:4</li>
                          <li>Cargo space: 1.8 x 1.8 x 3.5 m (H x W x L)</li>
                        </ul>
                      </span>
                    </div>
                  </div>
                  <div
                    className="col-xs-12 col-md-3"
                    style={{ textAlign: "center" }}
                  ></div>
                </div>
              </div>
              <div
                className="col-xs-12 col-md-6"
                style={{ textAlign: "center" }}
              >
                <img
                  className="img-fluid"
                  src="https://images.hertz.com/content/dam/hod/images/en-gb/static/FordCustomSWB.png"
                  alt=""
                />
                <br /> <br />
                <div className="row">
                  <div
                    className="col-xs-12 col-md-4"
                    style={{ textAlign: "center" }}
                  ></div>
                  <div
                    className="col-xs-12 col-md-5"
                    style={{ textAlign: "center" }}
                  >
                    <div style={{ textAlign: "left" }}>
                      <p className="h2">Opel Vivaro</p>
                      <p className="h6">or similar</p>
                      <span>
                        <ul>
                          <li>Doors:5</li>
                          <li>Cargo space: 1.20 x 1.25 x 2.70 m (H x W x L)</li>
                        </ul>
                      </span>
                    </div>
                  </div>
                  <div
                    className="col-xs-12 col-md-3"
                    style={{ textAlign: "center" }}
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12 col-md-6" style={{ textAlign: "center" }}>
            <img
              className="img-fluid"
              src="https://images.hertz.com/content/dam/hod/images/en-gb/static/Mobile_DE.png"
              alt=""
            />
          </div>
          <div
            className="col-xs-12 col-md-6 py-md-5"
            style={{ textAlign: "center" }}
          >
            <h1 className="display-5">
              <b>Our locations</b>
            </h1>
            <p>
              With over 700 locations across Europe, a Hertz 24/7® vehicle is
              closer than you think.
            </p>
            <div className="row">
              <div
                className="col-xs-12 col-md-4 "
                style={{ textAlign: "left" }}
              >
                <p>
                  <b>United Kingdom (300 locations)</b>
                </p>
                <p>
                  <a
                    href="https://booking.hertz247.com/booking/book?location=prk-gb13121600020009&product=HOURLY_RENTAL"
                    style={{ textDecoration: "none" }}
                  >
                    Manchester
                  </a>
                </p>
                <p>
                  <a
                    href="https://booking.hertz247.com/booking/book?location=prk-gb11082902024006&product=HOURLY_RENTAL"
                    style={{ textDecoration: "none" }}
                  >
                    London
                  </a>
                </p>
              </div>
              <div
                className="col-xs-12 col-md-4 "
                style={{ textAlign: "left" }}
              >
                <p>
                  <b>France (20 locations)</b>
                </p>
                <p>
                  <a
                    href="https://booking.hertz247.com/booking/book?location=prk-fr19100400001005&product=HOURLY_RENTAL"
                    style={{ textDecoration: "none" }}
                  >
                    Paris
                  </a>
                </p>
                <p>
                  <a
                    href="https://booking.hertz247.com/booking/book?location=prk-fr19110500007004&product=HOURLY_RENTAL"
                    style={{ textDecoration: "none" }}
                  >
                    Marseilles
                  </a>
                </p>
              </div>
              <div
                className="col-xs-12 col-md-4 "
                style={{ textAlign: "left" }}
              >
                <p>
                  <b>Germany (280 locations)</b>
                </p>
                <p>
                  <a
                    href="https://booking.hertz247.com/booking/book?location=prk-de18112800001004&product=HOURLY_RENTAL"
                    style={{ textDecoration: "none" }}
                  >
                    Berlin
                  </a>
                </p>
                <p>
                  <a
                    href="https://booking.hertz247.com/booking/book?location=prk-de15102900001000&product=HOURLY_RENTAL"
                    style={{ textDecoration: "none" }}
                  >
                    Frankfurt
                  </a>
                </p>
              </div>
              <div
                className="col-xs-12 col-md-4 "
                style={{ textAlign: "left" }}
              >
                <p>
                  <b>Italy (75 locations)</b>
                </p>
                <p>
                  <a
                    href="https://booking.hertz247.com/booking/book?location=prk-it17072800007000&product=HOURLY_RENTAL"
                    style={{ textDecoration: "none" }}
                  >
                    Rome
                  </a>
                </p>
                <p>
                  <a
                    href="https://booking.hertz247.com/booking/book?location=prk-it17072800005002&product=HOURLY_RENTAL"
                    style={{ textDecoration: "none" }}
                  >
                    Milan
                  </a>
                </p>
              </div>
              <div
                className="col-xs-12 col-md-4 "
                style={{ textAlign: "left" }}
              >
                <p>
                  <b>Portugal (39 locations)</b>
                </p>
                <p>
                  <a
                    href="https://booking.hertz247.com/booking/book?location=prk-pt21051200001008&product=HOURLY_RENTAL"
                    style={{ textDecoration: "none" }}
                  >
                    Lisbon
                  </a>
                </p>
                <p>
                  <a
                    href="https://booking.hertz247.com/booking/book?location=prk-pt17062200003001&product=HOURLY_RENTAL"
                    style={{ textDecoration: "none" }}
                  >
                    Porto
                  </a>
                </p>
              </div>
              <div
                className="col-xs-12 col-md-4 "
                style={{ textAlign: "left" }}
              >
                <p>
                  <b>Switzerland (4 locations)</b>
                </p>
                <p>
                  <a
                    href="https://booking.hertz247.com/booking/book?location=prk-chCHHZBRN&product=HOURLY_RENTAL"
                    style={{ textDecoration: "none" }}
                  >
                    Bern
                  </a>
                </p>
                <p>
                  <a
                    href="https://booking.hertz247.com/booking/book?location=prk-chCHHZLUG&product=HOURLY_RENTAL"
                    style={{ textDecoration: "none" }}
                  >
                    Lugano
                  </a>
                </p>
              </div>
            </div>
            <div className="row">
              <div className="col-xs-12" style={{ textAlign: "left" }}>
                <b>
                  <u>Explore locations near you &gt;</u>
                </b>
                <br />
                <br />
              </div>
            </div>
            <div className="row">
              <div
                className="col-xs-12 col-md-6"
                style={{ textAlign: "right" }}
              >
                <div className="row">
                  <div
                    className="col-xs-12 col-md-5"
                    style={{ textAlign: "left" }}
                  >
                    <a href="https://apps.apple.com/de/app/hertz-24-7-mobility/id6453605078">
                      <img
                        className="img-fluid"
                        src="https://images.hertz.com/content/dam/hod/images/en-gb/static/AppleAppStore.png"
                        alt=""
                        width={250}
                      />
                    </a>
                  </div>
                  <div
                    className="col-xs-12 col-md-1"
                    style={{ textAlign: "center" }}
                  >
                    &nbsp;
                  </div>
                  <div
                    className="col-xs-12 col-md-5"
                    style={{ textAlign: "left" }}
                  >
                    <a href="https://play.google.com/store/apps/details?id=com.hertz247.driverApp&hl=de_de&gl=de">
                      <img
                        className="img-fluid"
                        src="https://images.hertz.com/content/dam/hod/images/en-gb/static/GooglePlayStore.png"
                        alt=""
                        width={250}
                      />
                    </a>
                  </div>
                  <div
                    className="col-xs-12 col-md-1"
                    style={{ textAlign: "center" }}
                  >
                    &nbsp;
                  </div>
                </div>
              </div>
              <div
                className="col-xs-12 col-md-6"
                style={{ textAlign: "left" }}
              ></div>
            </div>
          </div>
        </div>
        <div
          className="row p-4"
          style={{
            width: "100vw",
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        >
          <div
            className="row img-fluid"
            style={{
              backgroundImage:
                "url(https://images.hertz.com/content/dam/hod/images/en-gb/static/Transit_city.png)",
              backgroundSize: "cover",
            }}
          >
            <div className="col-xs-12 col-md-1"></div>
            <div className="col-xs-12 col-md-3">
              <br />
              <br />
              <br />
              <span>
                <h1 className="display-4">
                  <b>Why choose Hertz 24/7®?</b>
                </h1>
              </span>
              <p>
                With Hertz 24/7®, you can rent vehicles at competitive prices,
                with hourly and daily rates depending on the vehicle type and
                location. Your estimated rental price will be displayed at the
                time of booking*.
              </p>
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
            </div>
            <div className="col-xs-12 col-md-8"></div>
          </div>
        </div>

        <div className="row">
          <div
            className="col-xs-12 col-md-4"
            style={{ textAlign: "center", backgroundColor: "#fff7cc" }}
          >
            <br />
            <img
              className="img-fluid"
              src="https://images.hertz.com/content/dam/hod/images/en-gb/static/Contact.png"
              alt=""
            />
            <p className="h4">Customer support</p>
            <p>
              We are available during our opening hours to assist you personally
              if you experience any issues with your rental or the vehicle.
            </p>
          </div>
          <div
            className="col-xs-12 col-md-4 "
            style={{ textAlign: "center", backgroundColor: "#fff099" }}
          >
            <br />
            <img
              className="img-fluid"
              src="https://images.hertz.com/content/dam/hod/images/en-gb/static/Price.png"
              alt=""
            />
            <p className="h4">Simple pricing</p>
            <p>
              Book your vehicle at hourly or daily rates. Use membership numbers
              from our partners to access discounted offers.
            </p>
          </div>
          <div
            className="col-xs-12 col-md-4"
            style={{ textAlign: "center", backgroundColor: "#ffe866" }}
          >
            <br />
            <img
              className="img-fluid"
              src="https://images.hertz.com/content/dam/hod/images/en-gb/static/Location.png"
              alt=""
            />
            <p className="h4">Always nearby</p>
            <p>
              With over 700 locations across Europe, there is always a vehicle
              nearby.
            </p>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12" style={{ textAlign: "center" }}>
            <br />
            <span>
              <h6>
                *Kilometre rates may vary depending on the selected vehicle
                type.
              </h6>
            </span>
            <span>
              <h6>
                Always check the applicable kilometre rates at the time of your
                booking.
              </h6>
            </span>
          </div>
        </div>
      </div>
    </>
  );
}
export default CHUKHomeBody;
